import { Flex } from "components/common"
import {
  useGetClientsRecommendedProjectsQuery,
  useGetClientsSalesPlaybookProjectDetailsQuery,
} from "features/leads/api"
import { useCallback, useEffect, useMemo, useState } from "react"
import styles from "../index.module.less"
import ProjectCard from "./ProjectCard"
import ProjectDetails from "./ProjectDetails"
import { useLazyGetListingProjectsQuery } from "features/projects/api"

const ProjectKnowledge = ({ clientId, filterObject }) => {
  const [selectedProject, setSelectedProject] = useState(null)
  const [isFiltersReset, setIsFiltersReset] = useState(false)
  const {
    data: recommendedProjectsData,
    isFetching: isLoadingProjects,
    error: recommendedProjectsError,
    refetch: refetchRecommendedProjects,
  } = useGetClientsRecommendedProjectsQuery({ clientId, status: "on" }, { skip: !clientId })
  const [getProjects, { data: systemProjects, isFetching: isFetchingSystemProjects, error: systemProjectsError }] =
    useLazyGetListingProjectsQuery()
  const {
    data: projectDetailsData,
    isFetching: isLoadingProjectDetails,
    error: projectDetailsError,
    refetch: refetchProjectDetails,
  } = useGetClientsSalesPlaybookProjectDetailsQuery(selectedProject?.projectId, {
    skip: !selectedProject?.projectId,
    refetchOnMountOrArgChange: true,
  })

  const recommendedProjects = useMemo(() => recommendedProjectsData || [], [recommendedProjectsData])

  // Auto-select first recommended project only if no filterObject.projectId is provided
  useEffect(() => {
    if (recommendedProjects.length > 0 && !selectedProject && !filterObject?.projectId) {
      const firstProject = recommendedProjects[0]
      setSelectedProject({ projectId: firstProject.projectId, interestedProject: firstProject.interestedProject })
    }
  }, [recommendedProjects, selectedProject, filterObject?.projectId])

  useEffect(() => {
    if (filterObject?.projectId) {
      setSelectedProject({ projectId: +filterObject?.projectId, interestedProject: filterObject?.interestedProject })
    }
  }, [filterObject?.projectId])

  useEffect(() => {
    if (Object?.keys(filterObject)?.length > 0) {
      getProjects({ ...filterObject, status: "on", page: 0, pageLimit: 20 })
      setIsFiltersReset(false)
    }
    if (Object?.keys(filterObject)?.length === 0 && systemProjects) {
      handleFilterReset(true)
    }
  }, [filterObject])

  const handleFilterReset = () => {
    setIsFiltersReset(true)
  }
  const handleSelectProject = useCallback(project => {
    setSelectedProject({ projectId: project.projectId, interestedProject: project.interestedProject })
  }, [])

  return (
    <Flex vertical className={styles.tabContent} gap="32px">
      <ProjectCard
        projects={recommendedProjects}
        selectedProjectId={selectedProject?.projectId}
        onSelectProject={handleSelectProject}
        isLoading={isLoadingProjects || isFetchingSystemProjects}
        error={recommendedProjectsError || systemProjectsError}
        // onRetry={refetchRecommendedProjects} hidden duw to overcomlicated logic of refetching the desired result will do it later
        isFiltersReset={isFiltersReset}
        systemProjects={systemProjects}
        filterProjectId={filterObject?.projectId}
      />
      {!recommendedProjectsError && selectedProject?.projectId && (
        <ProjectDetails
          project={projectDetailsData}
          isInterestedProject={selectedProject?.interestedProject}
          isLoading={isLoadingProjectDetails || isLoadingProjects}
          error={projectDetailsError}
          onRetry={refetchProjectDetails}
        />
      )}
    </Flex>
  )
}

ProjectKnowledge.displayName = "ProjectKnowledge"

export default ProjectKnowledge
